module.exports = __webpack_public_path__ + "img/icon2.cb152daf.png";